import { AccountConfigNonStandardProperties } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "accessibilityCompliance"
  | "adBlock"
  | "adPerformanceMeta"
  | "allowJsDynamicProp"
  | "analytics"
  | "audiences"
  | "audiencesIngest"
  | "audienceSegmentationUserProperties"
  | "cdaDashboard"
  | "chatSupport"
  | "contractAllowsAIUsage"
  | "dataConnectors"
  | "destinationsV2"
  | "disableMasqueradeWarningBanner"
  | "displayNewEventLibraryPage"
  | "emitAppointmentAttributionEvents"
  | "emitAppointmentAttributionEventsMeta"
  | "freshpaintAiChat"
  | "freshpaintConsentManagementUI"
  | "functions"
  | "googleAdsEnhancedConversionsPassthrough"
  | "gtmManagedEvents"
  | "heatmaps"
  | "hipaaV2"
  | "identityMatching"
  | "eventLibraryV2"
  | "marketingPerformanceAnalysis"
  | "eventIdentitySupport"
  | "networkEventDefs"
  | "personas"
  | "phoneNumberAudiences"
  | "podscribe"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "selfServeAuditLog"
  | "sessionReplayEnabled"
  | "sessionReplayRecordingPaused"
  | "shortLinks"
  | "sourceFunctions"
  | "sqlTransformations"
  | "sqlTransformationsv2"
  | "strictExternalIdMatching"
  | "traces"
  | "translation"
  | "botBlocking"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "videoPlayerCustomization"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI";

export type FlagGetter = (featureName: FeatureFlag) => boolean;

/**
 * Get the value of a feature flag
 */
interface FeatureFlagConfigurationLocation {
  config: Partial<
    Record<FeatureFlag, boolean> & AccountConfigNonStandardProperties
  >;
}
export function getFeature(
  accountMetadata: FeatureFlagConfigurationLocation,
  featureFlag: FeatureFlag,
): boolean {
  switch (featureFlag) {
    case "accessibilityCompliance":
    case "adBlock":
    case "adPerformanceMeta":
    case "allowJsDynamicProp":
    case "analytics":
    case "audiences":
    case "audiencesIngest":
    case "audienceSegmentationUserProperties":
    case "botBlocking":
    case "cdaDashboard":
    case "chatSupport":
    case "contractAllowsAIUsage":
    case "dataConnectors":
    case "destinationsV2":
    case "disableMasqueradeWarningBanner":
    case "displayNewEventLibraryPage":
    case "emitAppointmentAttributionEvents":
    case "emitAppointmentAttributionEventsMeta":
    case "freshpaintAiChat":
    case "freshpaintConsentManagementUI":
    case "functions":
    case "googleAdsEnhancedConversionsPassthrough":
    case "gtmManagedEvents":
    case "heatmaps":
    case "hipaaV2":
    case "identityMatching":
    case "eventLibraryV2":
    case "marketingPerformanceAnalysis":
    case "eventIdentitySupport":
    case "networkEventDefs":
    case "personas":
    case "phoneNumberAudiences":
    case "podscribe":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "selfServeAuditLog":
    case "sessionReplayEnabled":
    case "sessionReplayRecordingPaused":
    case "shortLinks":
    case "sourceFunctions":
    case "sqlTransformations":
    case "sqlTransformationsv2":
    case "strictExternalIdMatching":
    case "traces":
    case "translation":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "videoPlayerCustomization":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
